module.exports = __webpack_public_path__ + "img/TAU.c4f9cfb0.svg";